export default "__VITE_ASSET__77f25c6f__"